import { Box } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { FC } from 'react';

import { useImageStatus } from '../hooks/use-image-status';
import { AvatarInitials } from './avatar-initials';

const fadeIn = keyframes`
	from { opacity: 0; }
	to { opacity: 1; }
`;

interface AvatarImageProps {
	name?: string;
	src?: string;
}

const AvatarImage: FC<AvatarImageProps> = ({ name, src }) => {
	const { isLoaded } = useImageStatus(src);
	const showInitials = !src || !isLoaded;

	if (showInitials) {
		return <AvatarInitials name={name} />;
	}

	return <Box alt="" as="img" h="full" w="full" objectFit="cover" src={src} animation={`${fadeIn} 150ms ease-out`} />;
};

AvatarImage.displayName = 'AvatarImage';

export { AvatarImage };
